module.exports = __webpack_public_path__ + "img/Rules.d868d7a5.svg";